import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth";
import type { CarrierDropoffLocation } from "@/api.types.v2";

interface Origin {
  lat: number;
  lng: number;
}

export function useDropoffLocations(
  carrierId: string | undefined,
  origin: Origin | null
) {
  const { token } = useSession();

  return useQuery<CarrierDropoffLocation[], Error>({
    queryKey: [
      "dropoffLocations",
      carrierId,
      origin?.lat ?? null,
      origin?.lng ?? null,
    ] as const,
    queryFn: async () => {
      if (!carrierId) return [];
      const params: Record<string, string> = {};
      if (origin) {
        params.lat = String(origin.lat);
        params.lng = String(origin.lng);
      }
      const response = await axios.get<{ data: CarrierDropoffLocation[] }>(
        `${import.meta.env.VITE_API_URL}/api/v2/carriers/${carrierId}/dropoff-locations`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        }
      );
      return response.data.data;
    },
    enabled: !!carrierId && !!token,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
